import { ListItemIcon } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMenuListIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(3.75),
  '&.MuiListItemIcon-alignItemsFlexStart': {
    marginTop: theme.spacing(0.5),
  },
}));
